import { useRoutes } from '@/shared/routes';

export const epguRoutes = [
  {
    path: useRoutes.EPGU_LIST_PATH,
    name: useRoutes.EPGU_LIST_NAME,
    component: () => import('@/pages/RequestsUnified'),
  },
  {
    path: useRoutes.EPGU_ITEM_PATH,
    name: useRoutes.EPGU_ITEM_NAME,
    component: () => import('@/pages/RequestsUnified/ui'),
  },
];
